import Vue from 'vue';
import store from './store';
import module from '../store/wishlist';

const wishlist = {
    getIds() {
        const ids = [];
        this.store.state.wishlistProducts.forEach(wishlistProduct => ids.push(wishlistProduct.id));
        return ids;
    },
    isFavorite(productId) {
        let result = false;
        this.store.state.wishlistProducts.some(wishlistProduct => {
            result = wishlistProduct.id == productId;
            return result;
        });
        return result;
    },
    toggleProduct(productId) {
        if (this.isFavorite(productId)) {
            return this.removeProduct(productId);
        } else {
            return this.addProduct(productId);
        }
    },
    addProduct(productId) {
        return this.store
            .dispatch('addWishlistProduct', productId)
            .then(result => {
                if (result && result.success) {
                    Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                        message: 'Wir haben das Produkt auf deine Wunschliste gesetzt.',
                        buttonText: 'zum Wunschzettel',
                        buttonLink: {
                            name: 'customer-wishlist'
                        }
                    });
                } else {
                    Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                        message: 'Something went wrong. Please reload the page and try again.'
                    });
                }

                return result;
            })
            .catch(e => {
                console.log(e);
                Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                    message: 'Something went wrong. Please reload the page and try again.'
                });
            });
    },
    removeProduct(productId) {
        return this.store
            .dispatch('removeWishlistProduct', productId)
            .then(result => {
                if (result && result.success) {
                    Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                        message: 'Wir haben das Produkt von der Wunschliste gelöscht.',
                        buttonText: 'zum Wunschzettel',
                        buttonLink: {
                            name: 'customer-wishlist'
                        }
                    });
                } else {
                    Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                        message: 'Something went wrong. Please reload the page and try again.'
                    });
                }

                return result;
            })
            .catch(e => {
                console.log(e);
                Vue.$store.dispatch('NotificationModal/displayNotificationModal', {
                    message: 'Something went wrong. Please reload the page and try again.'
                });
            });
    },
    syncProducts() {
        this.store.dispatch('loadWishlistProducts');
    }
};

export default {
    install: function(Vue) {
        if (!Vue.$store.state['Wishlist']) {
            Vue.$store.registerModule('Wishlist', module);
        }
        wishlist.store = store;
        Vue.prototype.$wishlist = wishlist;
        Vue.$wishlist = wishlist;
        Vue.$store.watch(
            () => Vue.$store.getters['Login/isUserLoggedIn'],
            value => {
                if (value) {
                    wishlist.syncProducts();
                }
            },
            {
                immediate: true
            }
        );
    }
};
